import { render } from "./WohnungStep2.vue?vue&type=template&id=06a7ad84&scoped=true"
import script from "./WohnungStep2.vue?vue&type=script&lang=js"
export * from "./WohnungStep2.vue?vue&type=script&lang=js"

import "./WohnungStep2.vue?vue&type=style&index=0&id=06a7ad84&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a7ad84"]])

export default __exports__